// extracted by mini-css-extract-plugin
export var closeButton = "_cc-1";
export var closeX = "_cc-3";
export var container = "_cc-0";
export var image = "_cc-2";